import * as api from "./api/index";
import * as duck from "./duck";
import * as epic from "./epic";
import * as form from "./form";
import * as MoneySum from "./MoneySum";
import * as st from "./socialtravel";
import * as validators from "./validators";
import confirm, { createModal } from "./modal";
import authorize from "./authorize";

export default {
  ...st,
  api,
  duck,
  epic,
  form,
  MoneySum,
  validators,
  confirm,
  createModal,
  authorize,
};

export { st, api, duck, epic, form, MoneySum, validators, confirm, createModal, authorize };



// WEBPACK FOOTER //
// ./src/lib/utils/index.js